import { API_BASE_URL } from '../config/api';
import { createApiError } from './apiError';

export interface SignupRequest {
  email: string;
  password: string;
  firstName: string;
  lastName: string | null;
  studioName?: string | null;
  acceptedTermsVersion?: string;
  'cf-turnstile-response': string;
  /** Optional GA4 context captured before the signup request. */
  analytics?: {
    clientId: string;
    sessionId?: number;
  };
}

export interface SignupResponse {
  message: string;
  user?: {
    id: string;
    email: string;
    firstName: string;
    lastName: string | null;
    studioName?: string | null;
  };
}

export const signup = async (data: SignupRequest): Promise<SignupResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/auth/signup`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw createApiError(
        errorData.message || errorData.error || 'Signup failed.',
        errorData.code
      );
    }

    return response.json();
  } catch (error) {
    console.error('Sign Up Error:', error);
    throw error;
  }
};
